import {inject, Injectable} from '@angular/core';
import {Actions, concatLatestFrom, createEffect, ofType} from '@ngrx/effects';
import {concatMap, map} from 'rxjs';
import {DatevWizardConfigExistsActions} from './datev-wizard-config-exists.actions';
import {RouterActions} from '@adnova/jf-ng-components';
import {Store} from '@ngrx/store';
import {DatevWizardGetFirmaSelectors} from '../../datev-wizard-get-firma/+store/datev-wizard-get-firma.selectors';
import {DatevWizardClientIdSelectors} from '../../datev-wizard-client-id/+store/datev-wizard-client-id.selectors';
import {DatevWizardCaseSelectionSelectors} from '../../datev-wizard-case-selection/+store/datev-wizard-case-selection.selectors';


@Injectable()
export class DatevWizardConfigExistsEffects {

  private readonly _actions$ = inject(Actions);

  private readonly _store = inject(Store);

  readonly goToConfigDetails$ = createEffect(
    () => this._actions$.pipe(
      ofType(DatevWizardConfigExistsActions.goToConfigDetails),
      map(({ exportConfigId }) => {
        const url = `/datev/income-tax-documents/wizard/config-details/export-config-id/${exportConfigId}`;
        return RouterActions.navigateByUrl({url});
      }),
    ),
  );

  /**
   * Effect für Navigation zurück zur Client-ID Seite.
   * Navigiert zur Client-ID Seite mit firmenId und fall Parameter.
   */
  readonly goToClientId$ = createEffect(
    () => this._actions$.pipe(
      ofType(DatevWizardConfigExistsActions.goToClientId),
      concatLatestFrom(() => [
        this._store.select(DatevWizardCaseSelectionSelectors.selectedCase),
      ]),
      map(([{ firmenId }, selectedCase]) => {
        const fall = selectedCase; // 'fall1' oder 'fall2'
        const url = `/datev/income-tax-documents/wizard/client-id/inhaber/${firmenId}/fall/${fall}`;
        return RouterActions.navigateByUrl({ url });
      })
    )
  );

}
